// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/planner_relationship_details.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_studyo_today_planners_v1_resources_planner_relationship_kind } from "./planner_relationship_kind_pb.js";

/**
 * Describes the file studyo/today/planners/v1/resources/planner_relationship_details.proto.
 */
export const file_studyo_today_planners_v1_resources_planner_relationship_details = /*@__PURE__*/
  fileDesc("CkVzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3BsYW5uZXJfcmVsYXRpb25zaGlwX2RldGFpbHMucHJvdG8SInN0dWR5by50b2RheS5wbGFubmVycy52MS5yZXNvdXJjZXMi+QEKGlBsYW5uZXJSZWxhdGlvbnNoaXBEZXRhaWxzEg8KB3VzZXJfaWQYASABKAkSVwoScmVsYXRpb25zaGlwX2tpbmRzGAIgAygOMjsuc3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcy5QbGFubmVyUmVsYXRpb25zaGlwS2luZBIRCglmdWxsX25hbWUYAyABKAkSFQoNZW1haWxfYWRkcmVzcxgEIAEoCRITCgtwaWN0dXJlX3VybBgFIAEoCRIyCg5sYXN0X3NlZW5fdGltZRgGIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBCKqoCJ1N0dWR5by5Ub2RheS5QbGFubmVycy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z", [file_google_protobuf_timestamp, file_studyo_today_planners_v1_resources_planner_relationship_kind]);

/**
 * Describes the message studyo.today.planners.v1.resources.PlannerRelationshipDetails.
 * Use `create(PlannerRelationshipDetailsSchema)` to create a new message.
 */
export const PlannerRelationshipDetailsSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_planner_relationship_details, 0);

